import "./App.css";
import { Navigate, Route, Routes } from "react-router";
import { useAuth } from "./hooks/useAuth";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./modulez/auth/Login";
import MustOpenRoute from "./components/MustOpenRoute";
import Dashboard from "./modulez/dashboard/Dashboard";

import { contentPaths } from "./utils/static";
import ProjectLoader from "./modulez/project/ProjectLoader";
import ProjectSolutions from "./modulez/project/ProjectSolutions";
import UnitLoader from "./modulez/unit/UnitLoader";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InstructorNav from "./components/InstructorNav";
import DefinePassword from "./modulez/auth/DefinePassword";
import SinglePracticeView from "./modulez/SinglePracticeView";
import AllWeeks from "./modulez/dashboard/AllWeeks";
import CurrentWeek from "./modulez/dashboard/CurrentWeek";
import CurrentModuleView from "./modulez/dashboard/CurrentModuleView";
import LiveLessons from "./modulez/dashboard/LiveLessons";
import ReferralPage from "./modulez/referral/ReferralPage";
import AssignMain from "./modulez/admin/assign/AssignMain";
import ContentContextProvider from "./modulez/admin/add/ContentContextProvider";
import ScoresLoader from "./modulez/admin/scores/ScoresLoader";
import AddTestPractice from "./modulez/admin/practice/AddTestPractice";
import CurriculumMain from "./modulez/admin/curriculum/CurriculumMain";
import CurriculumRoadmap from "./modulez/curriculum/CurriculumRoadmap";
import OnboardingMain from "./modulez/onboarding/OnboardingMain";
import NotificationManager from "./modulez/notifications/NotificationManager";
import LevelUpOverlay from "./components/LevelUpOverlay";
import ModuleQuizMain from "./modulez/moduleQuiz/ModuleQuizMain";
import SingleQuizQuestionView from "./modulez/moduleQuiz/SingleQuizQuestionView";
import QuizReportMain from "./modulez/admin/moduleQuizReport/QuizReportMain";

// import PyodideRunner from "./components/PyodideRunner";
// import SocketTestPanel from "./components/SocketTestPanel";

function App() {
  const { user } = useAuth();
  return (
    <>
      {/* {user && user.role === 34 && <InstructorNav />} */}
      {/* <SocketTestPanel /> */}

      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Dashboard>
                <CurrentModuleView />
              </Dashboard>
            </PrivateRoute>
          }
        />

        <Route
          path="/ob"
          element={
            <PrivateRoute>
              <OnboardingMain />
            </PrivateRoute>
          }
        />

        <Route
          path="/hepsi"
          element={
            <PrivateRoute>
              <Dashboard>
                <AllWeeks cohortIds={[user?.cohort_id || 0]} />
              </Dashboard>
            </PrivateRoute>
          }
        />

        <Route
          path="/mufredat"
          element={
            <PrivateRoute>
              <Dashboard>
                <CurriculumRoadmap />
              </Dashboard>
            </PrivateRoute>
          }
        />

        <Route
          path="/canli-dersler"
          element={
            <PrivateRoute>
              <Dashboard>
                <LiveLessons />
              </Dashboard>
            </PrivateRoute>
          }
        />

        <Route
          path="/arkadasini-oner"
          element={
            <PrivateRoute>
              <Dashboard>
                <ReferralPage />
              </Dashboard>
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/test"
          element={
            <PrivateRoute>
              <PyodideRunner />
            </PrivateRoute>
          }
        /> */}

        <Route
          path={`/${contentPaths["UNIT"]}/:unitSlugWithId`}
          element={
            <PrivateRoute>
              <UnitLoader />
            </PrivateRoute>
          }
        />

        <Route
          path={`/alistirma/:practiceId`}
          element={
            <PrivateRoute>
              <SinglePracticeView />
            </PrivateRoute>
          }
        />

        {/* Tek soru bankasi sorusu (egitmen) — /alistirma/:id'nin banka karsiligi */}
        <Route
          path="/soru-bankasi/:questionId"
          element={
            <PrivateRoute>
              <SingleQuizQuestionView />
            </PrivateRoute>
          }
        />

        <Route
          path={`/${contentPaths["PROJECT"]}/:projectSlugWithId`}
          element={<ProjectLoader />}
        />

        <Route
          path="/proje-cozumleri/:projectSlugWithId"
          element={
            <PrivateRoute>
              <ProjectSolutions />
            </PrivateRoute>
          }
        />

        <Route
          path="/giris-yap"
          element={
            <MustOpenRoute>
              <Login />
            </MustOpenRoute>
          }
        />

        <Route
          path="/sifre-belirle"
          element={
            <MustOpenRoute>
              <DefinePassword />
            </MustOpenRoute>
          }
        />

        {/* admin stuff */}

        {user && user.role === 34 && (

          <>
            <Route
              path="/assign"
              element={
                <PrivateRoute>
                  <AssignMain />
                </PrivateRoute>
              }
            />

            <Route
              path="/edit-practice/:practiceId"
              element={
                <PrivateRoute>
                  <AddTestPractice />
                </PrivateRoute>
              }
            />

            <Route
              path="/contents"
              element={
                <PrivateRoute>
                  <ContentContextProvider />
                </PrivateRoute>
              }
            />
            <Route
              path="/scores/:cohortId"
              element={
                <PrivateRoute>
                  <ScoresLoader />
                </PrivateRoute>
              }
            />

            <Route
              path="/curriculum"
              element={
                <PrivateRoute>
                  <CurriculumMain />
                </PrivateRoute>
              }
            />

            <Route
              path="/module-practice-report"
              element={
                <PrivateRoute>
                  <Dashboard>
                    <QuizReportMain />
                  </Dashboard>
                </PrivateRoute>
              }
            />

          </>
        )}

        <Route
          path="/module-practice/:moduleId"
          element={
            <PrivateRoute>
              <ModuleQuizMain />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {user && <LevelUpOverlay />}
      <NotificationManager />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="dark"
        className={"text-sm"}
        progressClassName={"h-0.5 bg-amber-400"}
      />
    </>
  );
}

export default App;
